/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../../hooks/useForm';
import { getTaxProdList } from '../../../apis/tax-portal/billing';
import { getParams } from '../../../utils/params';
import { ControlTable } from '../../Table';
import Filters from '../../Filters';
import Modal, { ModalHeader } from '../../Modal';

const TaxProdListModal = (props) => {
  const { open, setOpen, submit } = props;
  const [filters] = useState([
    { title: "상품명 검색", key: "search.title" }
  ]);
  const [fields] = useState([
    {
      title: "상품명",
      key: "title",
    },
    {
      title: "공급가액",
      key: "supplyAmt",
      transform: "comma"
    },
    {
      title: "부가세",
      key: "taxAmt",
      transform: "comma"
    },
    {
      title: "합계금액",
      key: "totalAmt",
      transform: "comma"
    },
    {
      title: "등록일",
      key: "createdTime",
      type: "datetime"
    }
  ]);

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
  };

  const {
    form,
    setSubmit,
    handleOnChange,
    // handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm({
    offset: 0,
    limit: 10,
  });

  useEffect(() => {
    setSubmit(_submit);
    _submit(form);
  }, []);


  const _submit = (form) => {
    getTaxProdList(getParams(form))
      .then(res => {
        const { rows, count } = res;
        setList(rows || []);
        setTotal(count);
      }).finally(() => setIsLoading(false));
  };


  const onSelect = (data, e) => {
    submit(data);
    cancel();
  };

  return (
    <>
      <Modal
        isOpen={open}
        close={cancel}
        className="taxPortal-billing-detail"
      >
        <ModalHeader>
          {`세무상품 목록`}
        </ModalHeader>
        <Filters
          filters={filters}
          isLoading={isLoading}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
        <ControlTable
          fields={fields}
          list={list}
          isLoading={isLoading}
          selectedList={selectedList}
          setSelected={setSelectedList}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          isControl={false}
          onSelect={onSelect}
        />
      </Modal>
    </>
  );
};

export default TaxProdListModal;;